export default __webpack_public_path__ + "static/media/cover-7-lg.d2b95e3a.png";